import TLang from "model/application/Lang";
import { aggregateValues } from "utils/utils";

import {
  TABLE_AGGREGATOR,
  TABLE_COLUMN_TYPE,
  TColumnType,
  TDataFormatted,
} from "./model";

export const formatColumnTypesForMatrix = (
  data: TDataFormatted[],
): TColumnType[] => {
  const res: TColumnType[] = [];
  if (data[0]) {
    Object.keys(data[0]).forEach((att) => {
      if (att.startsWith("_")) {
        res.push({
          label: "",
          name: att,
          type: TABLE_COLUMN_TYPE.TEXT,
        });
      } else {
        res.push({
          label: "",
          name: att,
          type: TABLE_COLUMN_TYPE.NUMBER,
        });
      }
    });
  }
  return res;
};

export const formatValue = (value: string | number): number | string => {
  if (!isNaN(Number(value)) && value !== "") {
    return Math.round(Number(value) * 100) / 100;
  }
  return value;
};
const getAggregatorLabel = (aggregator: TABLE_AGGREGATOR, lang: TLang) => {
  const langKey =
    lang.containers.dashboards.subCategories.dashboards.aggregator;
  return aggregator === TABLE_AGGREGATOR.MEAN ? langKey.average : langKey.sum;
};

export const buildAggregateRow = (
  columnTypes: TColumnType[],
  rowData: any[],
  aggregator: TABLE_AGGREGATOR,
  lang: TLang,
) => {
  const totalRow: Record<string, number | string | JSX.Element> = {};

  const label = getAggregatorLabel(aggregator, lang);

  columnTypes.forEach((column, index) => {
    const isFirstColumn = index === 0;
    const { type, name } = column;
    if (type === TABLE_COLUMN_TYPE.NUMBER) {
      const columnValues = rowData.map((r) => r[name]);
      const totalAggregation = aggregateValues(columnValues, aggregator);
      const formattedValue = formatValue(totalAggregation);
      if (isFirstColumn) {
        totalRow[name] = (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{label}</span>
            <span style={{ paddingLeft: "8px" }}>{formattedValue}</span>
          </div>
        );
      } else {
        totalRow[name] = formattedValue;
      }
    } else {
      totalRow[name] = isFirstColumn ? label : "";
    }
  });

  return totalRow;
};

export const getCleanRowData = (rowData: any[]) => {
  return rowData.sort((a, b) => {
    let bCleaned, aCleaned;
    if (rowData.length != 0 && rowData[0].hasOwnProperty("_displayed_name")) {
      bCleaned = b["_displayed_name"]
        ? b["_displayed_name"].toLowerCase()
        : b["_displayed_name"] != null
          ? b["_displayed_name"].toString()
          : "a";

      aCleaned = a["_displayed_name"]
        ? a["_displayed_name"].toLowerCase()
        : a["_displayed_name"] != null
          ? a["_displayed_name"].toString()
          : "a";
    } else {
      bCleaned = b["name"]
        ? b["name"].toLowerCase()
        : b["name"] != null
          ? b["name"].toString()
          : "a";

      aCleaned = a["name"]
        ? a["name"].toLowerCase()
        : a["name"] != null
          ? a["name"].toString()
          : "a";
    }

    return aCleaned < bCleaned ? -1 : 1;
  });
};

export const getScrollPosition = (classes: string) => {
  const element = document.querySelector(classes);

  if (element) {
    const x = element.scrollLeft;
    const y = element.scrollTop;
    return {
      x,
      y,
    };
  }

  return {
    x: 0,
    y: 0,
  };
};
